import React, { Component } from 'react'
import styled from 'styled-components'
import { UserDropdownItem } from './UserDropdownItem'

const UserDropdownContainer = styled.div`
  z-index: 10000;
  background-color: white;
  border: 1px grey solid;
  border-top: 0px;
  padding: 5px 0px 5px 0px;
  width: 100%;
`

const ItemStyle = styled.div`
  display: flex;
  margin: 5px 0px 5px 0px;
  align-items: center;
  justify-content: center;
  &:hover {
    background-color: ${props => props.theme.colors.grey1};
    cursor: pointer;
  }
`

const StyledDiv = styled.div`
  color: ${props => props.theme.colors.black1};
  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
  }
`

class UserDropdown extends Component {
  menuItems = [
    //{
    //label: 'Profile',
    //dest: ''
    //},
    {
      label: 'Explore',
      dest: '/explore',
    },
    {
      label: 'New report',
      dest: '/explore/new',
    },
    {
      label: 'Uploader',
      dest: '/explore/upload',
    },
    //{
    //label: 'Admin',
    //dest: '/admin'
    //},
    //{
    //label: 'Sign out',
    //dest: '/login',
    //callback: this.props.logOut,
    //},
  ]

  render() {
    return (
      this.props.open && (
        <UserDropdownContainer open={this.props.open}>
          {this.menuItems.map(item => (
            <UserDropdownItem
              key={item.label}
              label={item.label}
              dest={item.dest}
              callback={item.callback}
            />
          ))}
          <ItemStyle>
            <StyledDiv onClick={this.props.logOut}>Sign out</StyledDiv>
          </ItemStyle>
        </UserDropdownContainer>
      )
    )
  }
}

export default UserDropdown
